export default "__VITE_ASSET__CTi564Nn__"